

import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { getCurrentUser, fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';
import { signIn } from '@aws-amplify/auth';
import logo from "../../assets/images/logo.png";
import { toast } from 'react-toastify';
import { getTenant_id } from '../../helpers/firebase_helper';
import { setAuthorization } from '../../helpers/api_helper';

const Login = (props) => {
    useEffect(() => {
        const guser = (async () => {
            const token = localStorage.getItem('authUser')
            if (token) {
                props.router.navigate("/dashboard");
            }
        });

        guser();

    }, [])
    const [userLogin, setUserLogin] = useState({});
    const [passwordShow, setPasswordShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email || "",
            password: userLogin.password || "",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {

            setLoading(true);
            try {
                const { nextStep } = await signIn({
                    username: values.email,
                    password: values.password
                });
                const { signInStep } = nextStep

                switch (signInStep) {
                    case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
                        toast.warning("NEW_PASSWORD_REQUIRED")
                        props.router.navigate("/reset-password", { state: { email: values.email, password: values.password, nextStep }, });
                        break;
                    case "DONE":
                        const session = await fetchAuthSession();
                        const token = session.tokens.idToken ? session.tokens.idToken : ""
                        localStorage.setItem("token", token)
                        setAuthorization(token);
                        toast.success("Login Successfuly")
                        props.router.navigate("/dashboard");
                        const { username, userId, signInDetails } = await getCurrentUser();
                        const loginUser = {
                            username: username,
                            userId: userId
                        };
                        localStorage.setItem("authUser", JSON.stringify(loginUser))
                }
            } catch (error) {

                toast.error(error.message || "Error logging in");
            }
            setLoading(false);
        }
    });

    const socialSignIn = async (provider) => {
        try {
            const tenant_id = await getTenant_id();
            const user = await Auth.federatedSignIn({ provider });
            props.router.navigate("/dashboard");
        } catch (error) {
            console.log("Error with social sign-in", error);
            setError(error.message || "Error signing in with social account");
        }
    };

    useEffect(() => {
        if (error) {
            setTimeout(() => {
                setError("");
            }, 3000);
        }
    }, [error]);

    document.title = "Allied Electricals Chatbot | Login";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center sm-5 mb-2 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logo} alt="" height="150" />
                                        </Link>
                                    </div>
                                    {/* <p className="mt-2 fs-15 fw-medium">Evolving you digitaly</p> */}
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-2">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Welcome Back !</h5>
                                            <p className="text-muted">Sign in to continue to Allied Electricals Chatbot</p>
                                        </div>
                                        {error && (<Alert color="danger"> {error} </Alert>)}
                                        <div className="p-2 mt-4">
                                            <Form onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}>
                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={validation.touched.email && validation.errors.email ? true : false}
                                                    />
                                                    {validation.touched.email && validation.errors.email && (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={validation.touched.password && validation.errors.password ? true : false}
                                                        />
                                                        {validation.touched.password && validation.errors.password && (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        )}
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" onClick={() => setPasswordShow(!passwordShow)} id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div>

                                                <div className="mt-4 mb-4">
                                                    <Button color="success" disabled={loading} className="btn btn-success w-100" type="submit">
                                                        {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : "Sign In"}
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);


